/**
 * Station list helpers for the multi-select boarding/destination pickers.
 * Pure — imported by the client search UI.
 */
import type { Station } from "../page";

export function isSameStation(a: Station, b: Station): boolean {
  return a.stationID === b.stationID;
}

/**
 * Suggestions minus what the user has already added, so a chosen station never
 * sits in the dropdown as an un-actionable row.
 */
export function excludeSelectedStations(
  suggestions: Station[],
  selected: Station[]
): Station[] {
  if (selected.length === 0) return suggestions;
  const chosen = new Set(selected.map((station) => station.stationID));
  return suggestions.filter((station) => !chosen.has(station.stationID));
}
